import {store} from '@/core/utils/store'
import {url} from '@/core'
import {router} from '@/core'

const base = `${window.location.protocol}//${window.location.host}`

export const legacyRoute = (path) => {
  const href = `${base}/${path}`
  if (!window.legacyRoute) {
    console.warn('legacy route only works in staging / production')
    return
  }
  console.log('legacy route', href)
  window.legacyRoute(href)
  store.set(['route'], {name: 'v1'})
}
